import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { unFormatCurrency, unFormatUnknownUnit } from '@/common/utils/unFormatters';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { DiagnosticObjectiveActivityValidationSchema } from '../../schemas/diagnosticObjectiveActivity.schema';

interface UseCreateDiagnosticObjectiveActivityProps {
  diagnosticObjectiveId: string | undefined;
  options?: Partial<Omit<UseMutationOptions<
    unknown,
    ErrorResponse,
    DiagnosticObjectiveActivityValidationSchema
  >, 'mutationKey' | 'mutationFn'>>;
}

export const useCreateDiagnosticObjectiveActivity = ({
  diagnosticObjectiveId,
  options,
}: UseCreateDiagnosticObjectiveActivityProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['createDiagnosticObjectiveActivity'],
    mutationFn: (form) => {
      const payload = {
        diagnostic_objective_id: diagnosticObjectiveId,
        display_name: form.display_name,
        description: form.description,
        unit_price: form.unit_price && unFormatCurrency(form.unit_price),
        quantity: form.quantity && unFormatUnknownUnit(form.quantity),
        warranty_in_days: form.warranty_in_days && unFormatUnknownUnit(form.warranty_in_days),
        unit_for_quantity: form.unit_for_quantity?.value === 'hours'
          ? 'minutes'
          : form.unit_for_quantity?.value,
        technical_professional_ids: form.technical_professional.map(({ value }) => value),
        images_attachments_attributes: form.images_attachments_attributes?.length
          ? form.images_attachments_attributes.map((item) => ({ blob_id: item.id }))
          : undefined,
      }

      return privateAxios.post(`/maintenance/diagnostic_objective_activities`, {
        ...payload,
      });
    },
    ...options
  });
}
